(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["campaign-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('campaign-slideshow')) {
    customElements.define('campaign-slideshow', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-campaign-slide]'));
        this.buttons = Array.from(this.querySelectorAll('[data-campaign-button]'));
        this.current = 0;
        this.querySelector('[data-campaign-previous]')?.addEventListener('click', () => this.show(this.current - 1));
        this.querySelector('[data-campaign-next]')?.addEventListener('click', () => this.show(this.current + 1));
        this.buttons.forEach((button) => button.addEventListener('click', () => this.show(Number(button.dataset.campaignButton))));
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        this.start();
      }
      disconnectedCallback() { this.stop(); }
      show(index) {
        if (!this.slides.length) return;
        this.current = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === this.current;
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        this.buttons.forEach((button, buttonIndex) => {
          const active = buttonIndex === this.current;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-current', String(active));
        });
      }
      start() {
        this.stop();
        if (this.dataset.autoplay !== 'true' || this.slides.length < 2) return;
        this.timer = window.setInterval(() => this.show(this.current + 1), Number(this.dataset.interval) || 5000);
      }
      stop() { if (this.timer) window.clearInterval(this.timer); this.timer = null; }
    });
  }
  document.addEventListener('shopify:block:select', (event) => {
    const slide = event.target.closest('[data-campaign-slide]');
    const slideshow = slide?.closest('campaign-slideshow');
    if (slide && slideshow) slideshow.show(Number(slide.dataset.campaignSlide));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('footer-mobile-accordion')) {
    customElements.define(
      'footer-mobile-accordion',
      class extends HTMLElement {
        connectedCallback() {
          const brandGroup = Array.from(this.querySelectorAll(':scope > .group-block')).find(
            (group) => group.querySelector('.text-block h3')?.textContent.trim() === 'Brand Information'
          );

          if (!brandGroup || brandGroup.querySelector('.footer-brand-details')) return;

          const infoBlock = brandGroup.querySelector('.text-block:has(h3)');
          if (!infoBlock) return;

          brandGroup.classList.add('footer-brand-group');

          const details = document.createElement('details');
          details.className = 'footer-brand-details';
          const summary = document.createElement('summary');
          summary.className = 'footer-brand-details__summary';
          summary.textContent = 'Brand Information';
          details.append(summary);
          infoBlock.before(details);
          details.append(infoBlock);

          const media = window.matchMedia('(max-width: 749px)');
          const syncState = (event) => {
            details.open = !event.matches;
          };
          syncState(media);
          media.addEventListener('change', syncState);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["split-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('split-slideshow')) {
    customElements.define(
      'split-slideshow',
      class extends HTMLElement {
        connectedCallback() {
          this.slides = Array.from(this.querySelectorAll('[data-slide-index]'));
          this.buttons = Array.from(this.querySelectorAll('[data-slide-button]'));
          this.current = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
          this.querySelector('[data-previous]')?.addEventListener('click', () => this.show(this.current - 1));
          this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.current + 1));
          this.buttons.forEach((button) => {
            button.addEventListener('click', () => this.show(Number(button.dataset.slideButton)));
          });
          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => this.start());
          this.addEventListener('focusin', () => this.stop());
          this.addEventListener('focusout', () => this.start());
          this.start();
        }

        disconnectedCallback() {
          this.stop();
        }

        show(index) {
          if (this.slides.length === 0) return;
          this.current = (index + this.slides.length) % this.slides.length;
          this.slides.forEach((slide, slideIndex) => {
            const active = slideIndex === this.current;
            slide.hidden = !active;
            slide.classList.toggle('is-active', active);
            slide.setAttribute('aria-hidden', String(!active));
          });
          this.buttons.forEach((button, buttonIndex) => {
            const active = buttonIndex === this.current;
            button.classList.toggle('is-active', active);
            button.setAttribute('aria-current', String(active));
          });
        }

        start() {
          this.stop();
          if (this.dataset.autoplay !== 'true' || this.slides.length < 2) return;
          const interval = Number(this.dataset.interval) || 5000;
          this.timer = window.setInterval(() => this.show(this.current + 1), interval);
        }

        stop() {
          if (this.timer) window.clearInterval(this.timer);
          this.timer = null;
        }
      }
    );
  }

  document.addEventListener('shopify:block:select', (event) => {
    const slide = event.target.closest('[data-slide-index]');
    const slideshow = slide?.closest('split-slideshow');
    if (slide && slideshow) slideshow.show(Number(slide.dataset.slideIndex));
  });

  } catch(e) { console.error(e); }
})();
})();
